export default "/directory/static/service_area.93c1eef9.svg";